
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withSnackbar } from 'notistack';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';


class DeleteDialog extends Component {

  static propTypes = {
    item: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    buttonProps: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      loading: false,
      snackbarMessage: undefined,
      snackbarShow: false,
      snackbarSeverity: 'info'
    };

    this.handleDelete = this.handleDelete.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.openDialog = this.openDialog.bind(this);
  }

  setLoading = (value) => {
    this.setState({
      loading: value
    });
  };

  handleDelete = () => {
    const { item, onDelete } = this.props;
    const { loading } = this.state;
    if (loading) {
      return;
    }

    this.setLoading(true);

    axios.delete(item.meta.url).then(res => {
      this.closeDialog();
      onDelete(item);
    }).catch(err => {
      const response = err.response;

      if (response) {
        if (response.status === 403) {
          this.props.enqueueSnackbar(response.data.detail, {
            variant: 'error'
          });
        }
      }
    }).then(() => {
      this.setLoading(false);
    });
  };

  openDialog = () => {
    this.setState({isOpen: true});
  };

  closeDialog = () => {
    const { loading } = this.state;
    if (loading) {
      return;
    }

    this.setState({
      isOpen: false
    });
  };

  keydown = (e) => {
    const { isOpen } = this.state;
    if (isOpen) {
      const keyCode = e.key.toUpperCase();
      if (keyCode === 'ENTER') {
        this.handleDelete();
        e.preventDefault();
      }
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.keydown, false);
  }

  componentWillUnmount(){
    document.removeEventListener('keydown', this.keydown, false);
  }

  render() {
    const { loading, isOpen } = this.state;
    const { buttonProps, itemLabel, buttonRenderer } = this.props;
    return (
      <>
        {buttonRenderer && (
          buttonRenderer(this.openDialog)
        )}
        {!buttonRenderer && (
          <Button variant="outlined" color="secondary" onClick={this.openDialog} {...buttonProps}>
            Удалить
          </Button>
        )}

        <Dialog
          open={isOpen}
          onClose={this.closeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Вы действительно хотите удалить {itemLabel}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog} disabled={loading} color="primary">
              Отмена
            </Button>
            <Button onClick={this.handleDelete} disabled={loading} variant={'contained'} color="secondary" autoFocus>
              Удалить
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withSnackbar(DeleteDialog);
